"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _phrase = _interopRequireDefault(require("../../../libs/translationsUtils/phrase"));

var _IdeationStatus = _interopRequireDefault(require("../IdeationStatus"));

var FromReply = function FromReply(_ref) {
  var oldIdeationStatus = _ref.oldIdeationStatus,
      newIdeationStatus = _ref.newIdeationStatus,
      toIdeaUrl = _ref.toIdeaUrl;
  var statusChanged = oldIdeationStatus.id !== newIdeationStatus.id;
  return (0, _preact.h)("div", null, statusChanged && (0, _preact.h)("div", null, (0, _preact.h)(_phrase.default, {
    p: "reply.idea.status.changed",
    m: "Common"
  }), (0, _preact.h)(_IdeationStatus.default, {
    ideationStatus: oldIdeationStatus
  }), "\u2192", (0, _preact.h)(_IdeationStatus.default, {
    ideationStatus: newIdeationStatus
  })), (0, _preact.h)(_phrase.default, {
    p: "idea.merge.from",
    m: "Control"
  }), (0, _preact.h)("br", null), (0, _preact.h)("oembed", {
    url: toIdeaUrl
  }), (0, _preact.h)("br", null), (0, _preact.h)(_phrase.default, {
    p: "idea.merge.from.votes",
    m: "Control"
  }));
};

var _default = FromReply;
exports.default = _default;